import { render, staticRenderFns } from "./washing.vue?vue&type=template&id=833a8d2a&scoped=true&"
import script from "./washing.vue?vue&type=script&lang=js&"
export * from "./washing.vue?vue&type=script&lang=js&"
import style0 from "./washing.vue?vue&type=style&index=0&id=833a8d2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833a8d2a",
  null
  
)

export default component.exports